/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { EnumPublicationStatusFromJSON, EnumPublicationStatusToJSON } from './EnumPublicationStatus';
import { EnumSharingStatusFromJSON, EnumSharingStatusToJSON } from './EnumSharingStatus';
import { SiteCoverPhotoFromJSON, SiteCoverPhotoToJSON } from './SiteCoverPhoto';
import { SiteMiscSettingFromJSON, SiteMiscSettingToJSON } from './SiteMiscSetting';
import { SiteShareFromJSON, SiteShareToJSON } from './SiteShare';
import { StatisticObjectFromJSON, StatisticObjectToJSON } from './StatisticObject';
import { UserForDisplayFromJSON, UserForDisplayToJSON } from './UserForDisplay';
export function SiteFromJSON(json) {
    return SiteFromJSONTyped(json, false);
}
export function SiteFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        publishedAt: !exists(json, 'published_at') ? undefined : json['published_at'],
        isPublished: !exists(json, 'is_published') ? undefined : json['is_published'],
        sharingStatus: !exists(json, 'sharing_status') ? undefined : EnumSharingStatusFromJSON(json['sharing_status']),
        publicationStatus: !exists(json, 'publication_status')
            ? undefined
            : EnumPublicationStatusFromJSON(json['publication_status']),
        title: !exists(json, 'title') ? undefined : json['title'],
        description: !exists(json, 'description') ? undefined : json['description'],
        memo: !exists(json, 'memo') ? undefined : json['memo'],
        coverPhoto: !exists(json, 'cover_photo') ? undefined : SiteCoverPhotoFromJSON(json['cover_photo']),
        isConfidential: !exists(json, 'is_confidential') ? undefined : json['is_confidential'],
        confidentialLabelName: !exists(json, 'confidential_label_name') ? undefined : json['confidential_label_name'],
        isHeaderCustom: !exists(json, 'is_header_custom') ? undefined : json['is_header_custom'],
        headerLogo: !exists(json, 'header_logo') ? undefined : SiteCoverPhotoFromJSON(json['header_logo']),
        isFooterCustom: !exists(json, 'is_footer_custom') ? undefined : json['is_footer_custom'],
        footerText: !exists(json, 'footer_text') ? undefined : json['footer_text'],
        archivedAt: !exists(json, 'archived_at') ? undefined : json['archived_at'],
        createdAt: !exists(json, 'created_at') ? undefined : json['created_at'],
        updatedAt: !exists(json, 'updated_at') ? undefined : json['updated_at'],
        siteShare: !exists(json, 'site_share') ? undefined : SiteShareFromJSON(json['site_share']),
        siteMiscSetting: !exists(json, 'site_misc_setting')
            ? undefined
            : SiteMiscSettingFromJSON(json['site_misc_setting']),
        user: !exists(json, 'user') ? undefined : UserForDisplayFromJSON(json['user']),
        createdBy: !exists(json, 'created_by') ? undefined : UserForDisplayFromJSON(json['created_by']),
        updatedBy: !exists(json, 'updated_by') ? undefined : UserForDisplayFromJSON(json['updated_by']),
        statisticObject: !exists(json, 'statistic_object') ? undefined : StatisticObjectFromJSON(json['statistic_object'])
    };
}
export function SiteToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        published_at: value.publishedAt,
        is_published: value.isPublished,
        sharing_status: EnumSharingStatusToJSON(value.sharingStatus),
        publication_status: EnumPublicationStatusToJSON(value.publicationStatus),
        title: value.title,
        description: value.description,
        memo: value.memo,
        cover_photo: SiteCoverPhotoToJSON(value.coverPhoto),
        is_confidential: value.isConfidential,
        confidential_label_name: value.confidentialLabelName,
        is_header_custom: value.isHeaderCustom,
        header_logo: SiteCoverPhotoToJSON(value.headerLogo),
        is_footer_custom: value.isFooterCustom,
        footer_text: value.footerText,
        archived_at: value.archivedAt,
        created_at: value.createdAt,
        updated_at: value.updatedAt,
        site_share: SiteShareToJSON(value.siteShare),
        site_misc_setting: SiteMiscSettingToJSON(value.siteMiscSetting),
        user: UserForDisplayToJSON(value.user),
        created_by: UserForDisplayToJSON(value.createdBy),
        updated_by: UserForDisplayToJSON(value.updatedBy),
        statistic_object: StatisticObjectToJSON(value.statisticObject)
    };
}
